export default __webpack_public_path__ + "static/media/big-illu.de692fed.svg";